'use client'
import { Suspense } from 'react'
import Error from '@/components/Error'
import ErrorBoundary from '@/components/ErrorBoundary'
import { QuickLinks } from '@/components/QuickLinks'
import SubmitButton from '@/components/SubmitButton'
import { flushRedisAction } from '@/operations/flushRedisAction'

function FlushRedisCache() {
  if (process.env.NEXT_PUBLIC_REVISION !== 'dev' || process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === 'test') return null
  return (
    <QuickLinks id="flush-redis-cache">
      <ErrorBoundary errorComponent={Error}>
        <Suspense fallback={null}>
          <form action={flushRedisAction}>
            <input type="hidden" name="revision" value={process.env.NEXT_PUBLIC_REVISION} />
            <SubmitButton>Flush Redis Cache</SubmitButton>
          </form>
        </Suspense>
      </ErrorBoundary>
    </QuickLinks>
  )
}

export default FlushRedisCache
